import axios from 'axios'

/**
 *
 */
export default class {
    //
    static appends = []
    static filters = []
    static headers = []
    static includes = []

    //
    static model = null

    /**
     *
     */
    static async create(data) {
        //
        const Model = this.model

        //
        try {
            //
            const newModel = new Model(data),
                response = await newModel.save()

            //
            return response
        } catch (error) {
            //
            return error.response.data
        }
    }

    /**
     *
     */
    static async delete(id) {
        //
        const Model = this.model

        //
        try {
            //
            const currModel = await Model.find(id),
                response = await currModel.delete()

            //
            return response.data
        } catch (error) {
            //
            return error.response.data
        }
    }

    /**
     *
     */
    static async fetchAll() {
        //
        try {
            //
            const response = await this.modeler()
                .params({ get_all_results: true })
                .get()

            //
            return response.data
        } catch (error) {
            //
            return error.response.data
        }
    }

    /**
     *
     */
    static async fetchBy(key, value) {
        //
        try {
            //
            const response = await this.modeler()
                .where(key, value)
                .get()

            //
            return response.data
        } catch (error) {
            //
            return error.response.data
        }
    }

    /**
     *
     */
    static async fetchById(id) {
        //
        try {
            //
            const response = await this.modeler().find(id)

            //
            return response
        } catch (error) {
            //
            return error.response
        }
    }

    /**
     *
     */
    static async fetchDataTable(limit, page, sort, params = {}) {
        //
        try {
            //
            return await this.modeler()
                .limit(limit)
                .page(page)
                .orderBy(sort)
                .params(params)
                .get()
        } catch (error) {
            //
            console.log(error)

            //
            return []
        }
    }

    /**
     * { function_description }
     *
     * @param      {<type>}  [data={}]  The data
     * @return     {Model}   { description_of_the_return_value }
     */
    static shape(data = {}) {

        //
        const Model = this.model

        //
        return new Model(data)
    }

    /**
     *
     */
    static modeler() {
        return this.model.append(this.appends).include(this.includes)
    }

    /**
     *
     */
    static async update(id, data) {
        //
        const Model = this.model

        //
        try {
            //
            const response = await axios.patch(
                new Model()
                    .endpoint()
                    .concat('/')
                    .concat(id),
                data
            )

            //
            return response.data
        } catch (error) {
            //
            return error.response.data
        }
    }
}
